<template>
	<v-row
		align="center"
		justify="center"
	>
		<v-col
			cols="11"
		>
			<h1>{{ title }}</h1>
		</v-col>
	</v-row>
</template>

<script>
	export default {
		name: 'Title',
		props: ['title']
	}
</script>